module.exports = __webpack_public_path__ + "static/media/char_patient.5a1f855b.png";